/**
 * @name robot-vacuum
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMTdoMiIgLz4KICA8cGF0aCBkPSJNMTIgMTJoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xNyAxMmE1IDUgMCAwMC0xMCAwIiAvPgogIDxwYXRoIGQ9Ik0xOSAydjIuOCIgLz4KICA8cGF0aCBkPSJNMiA1aDIuOCIgLz4KICA8cGF0aCBkPSJNMjIgNWgtMi44IiAvPgogIDxwYXRoIGQ9Ik01IDJ2Mi44IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/robot-vacuum
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const RobotVacuum: string = `
<svg
  class="lucide lucide-robot-vacuum"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M11 17h2" />
  <path d="M12 12h.01" />
  <path d="M17 12a5 5 0 00-10 0" />
  <path d="M19 2v2.8" />
  <path d="M2 5h2.8" />
  <path d="M22 5h-2.8" />
  <path d="M5 2v2.8" />
  <circle cx="12" cy="12" r="10" />
</svg>
`;

export default RobotVacuum;
